import optimizedWindowResizeInit from './utils/optimizedWindowResize';

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
	window.Popper = require('popper.js').default;
	window.$ = window.jQuery = require('jquery');

	require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if(!!window.LocalizationConfig && !!window.LocalizationConfig['locale']) {
	window.axios.defaults.headers.common['APP-LOCALE'] = window.LocalizationConfig['locale'];
}

window.axios.defaults.baseURL = '/api';

//window.axios.interceptors.request.use(config => config, error => Promise.reject(error));

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

/**
 * Creating custom window resize event.
 * It is a wrapper for native onresize, but is optimized.
 * event name: optimizedResize
 */
optimizedWindowResizeInit();

/**
 * Smoth scroll
 */
$(document).on('click', 'a[href^="#"]', function(event) {
	event.preventDefault();
	const $target = $(this).attr('href');

	if($target !== undefined && $target !== '' && $target !== '#' && $($target).length > 0) {
		$('html, body').animate(
			{
				scrollTop: $($target).offset().top - 92,
			},
			500,
		);
	}
});


/**
  * Language picker JS
  */

$(document).on('click', '.mobile-navbar .navbar_language_dropdown .menu__item_link.has-dropdown-menu', function(e){
	e.preventDefault();
	const $this = $(this);
	const $wrapper = $this.closest('.navbar_language_dropdown');

	$wrapper.toggleClass('is-open');
});